export default __webpack_public_path__ + "static/media/sector 1.09a04788.jpg";